<template>
  <form
    class="db-2 screen"
    @submit.prevent="submitDetail"
  >
    <div>
      <div class="frame-1750">
        <div class="text-29 inter-normal-black-20px">
          Enter your payment information
        </div>
        <p class="text-46 inter-normal-storm-gray-14px">
          Your data is secure with us. Please enter the payment details to process further.
        </p>
      </div>
    </div>

    <div class="frame-1748">
      <div class="frame-1747">
        <div class="frame-1746">
          <div class="number-1 inter-normal-white-14px">
            1
          </div>
        </div>
        <div class="customise-plan inter-normal-black-16px">
          Customise Plan
        </div>
      </div>
      <svg
        width="40"
        class="line"
        height="1"
        viewBox="0 0 40 1"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="0.5"
          y1="0.5"
          x2="39.5"
          y2="0.5"
          stroke="#E8E8E8"
          stroke-linecap="round"
          stroke-dasharray="2 2"
        />
      </svg>
      <div class="frame-1748-1">
        <div class="frame-1746-1">
          <div class="number inter-normal-white-14px">
            2
          </div>
        </div>
        <div class="payment-information inter-normal-black-16px">
          Payment Information
        </div>
      </div>
      <svg
        width="40"
        class="line"
        height="1"
        viewBox="0 0 40 1"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="0.5"
          y1="0.5"
          x2="39.5"
          y2="0.5"
          stroke="#E8E8E8"
          stroke-linecap="round"
          stroke-dasharray="2 2"
        />
      </svg>
      <div class="frame-1749">
        <div class="frame-1746-2">
          <div class="number inter-normal-storm-gray-14px">
            3
          </div>
        </div>
        <div class="text-44 inter-normal-storm-gray-16px">
          Review and make payment
        </div>
      </div>
    </div>
    <div
      id="payment-form"
      class="overlap-group"
    >
      <div id="card-element-errors" />
      <div class="group-1988">
        <div class="overlap-group1-2">
          <div class="x3916641">
            <div class="label-i39166412068-hVcKjw">
              Card details
            </div>
            <div
              id="card-element"
              class="my-input"
            />
          </div>
        </div>
        <div class="x3916642">
          <div class="label-i39166422068-Hb91Ih">
            Card holder name
          </div>
          <input
            v-model="cardholder_name"
            class="i3916642-2079218"
            placeholder="Please enter the name of card holder"
            required
          >
        </div>

        <div class="x3916643">
          <div class="label-i39166432068-DB9Rsj">
            Residential details
          </div>
          <input
            v-model="residentialAddress"
            class="i3916643-2079218"
            placeholder="Enter your address"
            required
          >
        </div>

        <div class="x3916644">
          <div class="label-i39166442068-TJHaj6">
            Select country
          </div>
          <select
            v-model="selectedcountry"
            class="i3916644-2079218"
            required
          >
            <option
              :value="null"
              disabled
              hidden
            >
              Select Country...
            </option>
            <option
              v-for="country in countries"
              :key="country.value"
              :value="country.value"
              class="input-text-here-i391-nAROfg"
            >
              {{ country.label }}
            </option>
          </select>
        </div>
        <div class="flex-row-1">
          <div class="x3916645">
            <div class="label-i39166452068-qoI0DB">
              City
            </div>
            <input
              v-model="city"
              class="i3916645-2079218"
              placeholder="City"
              required
            >
          </div>

          <div class="x3916646">
            <div class="label-i39166462068-5DPfzb">
              State
            </div>
            <input
              v-model="state"
              class="i3916646-2079218"
              placeholder="State"
            >
          </div>

          <div class="x3916647">
            <div class="label-i39166472068-6hgxG2">
              Zip Code / Postal Code
            </div>
            <input
              v-model="postal_code"
              class="i3916647-2079218"
              placeholder="Zip/Postal Code"
              name="my-postal-code"
            >
          </div>
        </div>
      </div>
    </div>

    <button
      class="buttonsubscribe"
      type="submit"
    >
      <div class="text-50 roboto-medium-white-18px">
        Review details and proceed to payment
      </div>
    </button>
  </form>
</template>

<script>

import { mapActions } from 'vuex';
const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

export default {

  emits: ['selectedComp', 'togglePaymentBtn', 'getCardFields'],
  data() {
    return {
      cardholder_name: null,
      residentialAddress: null,
      selectedcountry: null,
      postal_code: null,
      state: null,
      city: null,
      loader: false,
      errormessage: '',
      succcess: '',
      finalConfirmation: null,
    };
  },
  computed: {
    countries() {
      const list = countries.getNames('en', { select: 'official' });
      return Object.keys(list).map((key) => ({ value: key, label: list[key] }));
    },
  },

  methods: {
    ...mapActions({
      createSubscription: 'subscription/createSubscription'
    }),

    async submitDetail() {
      let val = {
        cardholder_name: this.cardholder_name,
        residentialAddress: this.residentialAddress,
        selectedcountry: this.selectedcountry,
        postal_code: this.postal_code,
        city: this.city,
        state: this.state,
      };
      this.$emit('getCardFields', val);
      this.$emit('togglePaymentBtn');
    }
  },
};
</script>
<style scoped>

.my-input {
  padding: 16px;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  font-size: 22px;
  border-radius: 4px;
  height: 52px;
  position: relative;
  top: 23px;
  font-size: 16px;
  color: #94a3b8;
}

.db-2 {
  align-items: center;
  background-color: var(--white);
  display: flex;
  flex-direction: column;
  

}

.db-2 .headerdb-regular-option-1 {
  align-items: center;
  background-color: var(--white);
  box-shadow: 0px 1px 0px #e2e8f0;
  display: flex;
  height: 60px;
  min-width: 1440px;
  padding: 0 40px;
}

.db-2 .frame-1737 {
  align-items: flex-start;
  display: flex;
  min-width: 327px;
}

.db-2 .big-1 {
  height: 32px;
  object-fit: cover;
  width: 70px;
}

.db-2 .frame-1729 {
  align-items: center;
  display: flex;
  height: 40px;
  justify-content: flex-end;
  margin-left: 33px;
  min-width: 224px;
  padding: 0 6px;
}

.db-2 .dashboard {
  letter-spacing: 0;
  line-height: 24px;
  min-height: 24px;
  min-width: 87px;
  white-space: nowrap;
}

.db-2 .terminal {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 54px;
  min-height: 24px;
  min-width: 69px;
  white-space: nowrap;
}

.db-2 .icon {
  align-items: flex-end;
  display: flex;
  height: 20px;
  margin-left: 611px;
  padding: 0.8px;
  width: 20px;
}

.db-2 .overlap-group1 {
  height: 18px;
  margin-left: 1px;
  position: relative;
  width: 18px;
}

.db-2 .vector {
  height: 16px;
  left: 0;
  position: absolute;
  top: 0;
  width: 16px;
}

.db-2 .vector-1 {
  height: 7px;
  left: 11px;
  position: absolute;
  top: 11px;
  width: 7px;
}

.db-2 .frame-1733 {
  align-items: center;
  display: flex;
  margin-left: 23px;
  min-width: 378px;
}

.db-2 .frame-1731 {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 33px;
  justify-content: flex-end;
  min-width: 71px;
  padding: 0 6px;
}

.db-2 .iconshelpinactive {
  /* background-image: url("../../../assets/img/icons-help--inactive@2x.svg"); */
  background-size: 100% 100%;
  height: 16px;
  margin-bottom: 0;
  width: 16px;
}

.db-2 .help {
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 8px;
  min-height: 17px;
  min-width: 33px;
  white-space: nowrap;
}

.db-2 .frame-1736 {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 36px;
  justify-content: flex-end;
  margin-left: 24px;
  min-width: 135px;
}

.db-2 .ellipse-4 {
  height: 32px;
  object-fit: cover;
  width: 32px;
}

.db-2 .frame-1734 {
  align-items: center;
  display: flex;
  height: 33px;
  margin-left: 2px;
  min-width: 99px;
  padding: 0 8px;
}

.db-2 .name {
  letter-spacing: 0;
  line-height: 17px;
  min-height: 17px;
  min-width: 65px;
  white-space: nowrap;
}

.db-2 .polygon-3 {
  height: 8px;
  margin-bottom: 0;
  margin-left: 7px;
  width: 10px;
}

.db-2 .frame-1732 {
  align-items: flex-start;
  cursor: pointer;
  display: flex;
  height: 35px;
  justify-content: flex-end;
  margin-left: 24px;
  min-width: 124px;
  padding: 8px 6px;
}

.db-2 .iconsnotificationinactive {
  align-items: flex-start;
  display: flex;
  height: 19px;
  min-width: 16px;
}

.db-2 .overlap-group1-1 {
  align-items: flex-start;
  /* background-image: url("../../../assets/img/icons-notification-inactive-4@2x.svg"); */
  background-size: 100% 100%;
  display: flex;
  height: 20px;
  justify-content: flex-end;
  margin-top: -0.4px;
  min-width: 16px;
  padding: 2.4px 0;
}

.db-2 .ellipse-3 {
  background-color: var(--djuli-secondary-color);
  border-radius: 3.5px;
  height: 7px;
  width: 7px;
}

.db-2 .notifications {
  align-self: center;
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 8px;
  min-height: 17px;
  min-width: 86px;
  white-space: nowrap;
}

.db-2 .flex-row {
  align-items: flex-start;
  /* align-self: flex-start; */
  display: flex;
  height: 114px;
  /* margin-left: 154px; */
  margin-top: 24px;
}

.db-2 .flex-col {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  min-height: 103px;
  width: 280px;
}

.db-2 .frame-1739 {
  align-items: flex-start;
  display: flex;
  height: 20px;
  min-width: 192px;
}

.db-2 .item {
  letter-spacing: 0;
  line-height: 17px;
  min-height: 17px;
  min-width: 42px;
  white-space: nowrap;
}

.db-2 .text-4 {
  letter-spacing: 0;
  line-height: 20px;
  margin-left: 2px;
  min-height: 20px;
  min-width: 7px;
  white-space: nowrap;
}

.db-2 .item-1 {
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 2px;
  min-height: 17px;
  min-width: 45px;
  white-space: nowrap;
}

.db-2 .item-2 {
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 2px;
  min-height: 17px;
  white-space: nowrap;
}

.db-2 .group-1989 {
  align-items: flex-start;
  align-self: flex-end;
  cursor: pointer;
  display: flex;
  margin-top: 35px;
  min-width: 123px;
}

.db-2 .overlap-group2 {
  align-items: flex-start;
  background-color: var(--white);
  border-radius: 4px;
  display: flex;
  height: 48px;
  min-width: 121px;
  padding: 17.5px 41.5px;
}

.db-2 .place {
  letter-spacing: 0;
  min-height: 12px;
  text-align: center;
  width: 38px;
}

.db-2 .frame-1750 {
  align-items: center;
  display: flex;
  flex-direction: column;
  /* margin-left: 1px; */
  /* margin-top: 24px; */
  align-items: center;
  display: flex;
  flex-direction: column;
  /* margin-left: 1px; */
  /* margin-top: 24px; */
  min-height: 70px;
  /* width: 355px; */
  margin-top: 3rem;
}

.db-2 .text-45 {
  letter-spacing: 0;
  line-height: 28px;
  margin-left: 2px;
  min-height: 28px;
  min-width: 300px;
  text-align: center;
  white-space: nowrap;
}

.db-2 .text-46 {
  letter-spacing: 0;
  line-height: 17px;
  margin-left: 2px;
  margin-top: 8px;
  min-height: 34px;
  text-align: center;
  width: 357px;
}

.db-2 .frame-1748 {
  align-items: center;
  display: flex;
  height: 48px;
  /* margin-left: 1px; */
  margin-top: 24px;
  /* min-width: 835px; */
  /* padding: 0 8px;*/
}

.db-2 .frame-1747 {
  align-items: center;
  display: flex;
  min-width: 157px;
}

.db-2 .frame-1746 {
  align-items: flex-end;
  background-color: var(--djuli-tertiary-color);
  border-radius: 16px;
  display: flex;
  height: 32px;
  justify-content: flex-end;
  min-width: 32px;
  padding: 7px 10px;
}

.db-2 .number-1 {
  letter-spacing: 0;
  line-height: 17px;
  min-height: 17px;
  min-width: 9px;
  white-space: nowrap;
}

.db-2 .customise-plan {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 8px;
  min-height: 24px;
  min-width: 119px;
  white-space: nowrap;
}

.db-2 .line {
  height: 1px;
  margin-left: 40px;
  width: 40px;
}

.db-2 .frame-1748-1 {
  align-items: center;
  display: flex;
  margin-left: 40px;
  min-width: 197px;
}

.db-2 .frame-1746-1 {
  align-items: flex-end;
  background-color: var(--djuli-tertiary-color);
  border-radius: 16px;
  display: flex;
  height: 32px;
  justify-content: flex-end;
  min-width: 32px;
  padding: 7px 8px;
}

.db-2 .number {
  letter-spacing: 0;
  line-height: 17px;
  min-height: 17px;
  min-width: 11px;
  white-space: nowrap;
}

.db-2 .payment-information {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 8px;
  min-height: 24px;
  min-width: 159px;
  white-space: nowrap;
}

.db-2 .frame-1749 {
  align-items: center;
  display: flex;
  margin-left: 40px;
  min-width: 225px;
}

.db-2 .frame-1746-2 {
  align-items: flex-end;
  background-color: var(--seashell);
  border-radius: 16px;
  display: flex;
  height: 32px;
  justify-content: flex-end;
  min-width: 32px;
  padding: 7px 8px;
}

.db-2 .text-44 {
  letter-spacing: 0;
  line-height: 24px;
  margin-left: 8px;
  min-height: 24px;
  min-width: 187px;
  white-space: nowrap;
}

.db-2 .overlap-group {
  height: 468px;
  margin-left: 2px;
  margin-top: 40px;
  position: relative;
  width: 562px;
}

.db-2 .group-1988 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  left: 0;
  position: absolute;
  top: 0;
  width: 562px;
}

.db-2 .overlap-group1-2 {
  border-radius: 5px;
  height: 76px;
  position: relative;
  width: 560px;
}

.x3916641 {
  border-radius: 5px;
  height: 76px;
  left: 0;
  opacity: 1;
  position: absolute;
  top: 0;
  width: 560px;
}

.x3916641 .label-i39166412068-hVcKjw {
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  left: 0;
  letter-spacing: 0;
  line-height: 17px;
  opacity: 1;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.i3916641-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 560px;
}

.i3916641-2079218 .input-text-here-i391-vY8Ah7 {
  color: #94a3b8;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  left: 16px;
  letter-spacing: 0;
  line-height: 24px;
  opacity: 1;
  position: absolute;
  top: 14px;
  white-space: nowrap;
}

input {
  color: #94a3b8;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  left: 16px;
  letter-spacing: 0;
  line-height: 24px;
  opacity: 1;
  position: absolute;
  top: 14px;
  white-space: nowrap;
  padding: 1rem;
}
input:focus {
  border: 1px solid var(--djuli-primary-color);
  outline: none;
  color: var(--storm-gray);
  font-size: 14px;
}
select {
  color: #94a3b8;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  left: 16px;
  letter-spacing: 0;
  line-height: 24px;
  opacity: 1;
  position: absolute;
  top: 14px;
  white-space: nowrap;
  padding: 1rem;
}

select:focus {
  border: 1px solid var(--djuli-primary-color);
  outline: none;
  color: var(--storm-gray);
  font-size: 14px;
}

input::placeholder {
  color: #94a3b8;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  left: 16px;
  letter-spacing: 0;
  line-height: 24px;
  opacity: 1;
  position: absolute;
  top: 14px;
  white-space: nowrap;
}

.db-2 .mm-yy {
  left: 404px;
  letter-spacing: 0;
  line-height: 24px;
  position: absolute;
  top: 38px;
  white-space: nowrap;
}

.x3916642 {
  border-radius: 5px;
  height: 76px;
  margin-top: 24px;
  opacity: 1;
  position: relative;
  width: 560px;
}

.x3916642 .label-i39166422068-Hb91Ih {
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  left: 0;
  letter-spacing: 0;
  line-height: 17px;
  opacity: 1;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.i3916642-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 560px;
}

.i3916642-2079218 .input-text-here-i391-gcGk2F {
  color: #94a3b8;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  left: 16px;
  letter-spacing: 0;
  line-height: 24px;
  opacity: 1;
  position: absolute;
  top: 14px;
  white-space: nowrap;
}

.x3916643 {
  border-radius: 5px;
  height: 76px;
  margin-top: 24px;
  opacity: 1;
  position: relative;
  width: 560px;
}

.x3916643 .label-i39166432068-DB9Rsj {
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  left: 0;
  letter-spacing: 0;
  line-height: 17px;
  opacity: 1;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.i3916643-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 560px;
}

.i3916643-2079218 .input-text-here-i391-2xvqCY {
  color: #94a3b8;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  left: 16px;
  letter-spacing: 0;
  line-height: 24px;
  opacity: 1;
  position: absolute;
  top: 14px;
  white-space: nowrap;
}

.x3916644 {
  border-radius: 5px;
  height: 76px;
  margin-top: 24px;
  opacity: 1;
  position: relative;
  width: 560px;
}

.x3916644 .label-i39166442068-TJHaj6 {
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  left: 0;
  letter-spacing: 0;
  line-height: 17px;
  opacity: 1;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.i3916644-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 560px;
}

.i3916644-2079218 .input-text-here-i391-nAROfg {
  color: #0f172a;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  left: 16px;
  letter-spacing: 0;
  line-height: 24px;
  opacity: 1;
  position: absolute;
  top: 14px;
  white-space: nowrap;
}

.db-2 .flex-row-1 {
  align-items: flex-start;
  display: flex;
  margin-top: 16px;
  min-width: 560px;
}

.x3916645 {
  border-radius: 5px;
  height: 76px;
  opacity: 1;
  position: relative;
  width: 176px;
}

.x3916645 .label-i39166452068-qoI0DB {
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  left: 0;
  letter-spacing: 0;
  line-height: 17px;
  opacity: 1;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.i3916645-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 176px;
}

.i3916645-2079218 .input-text-here-i391-FWsxA8 {
  color: #0f172a;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  left: 16px;
  letter-spacing: 0;
  line-height: 24px;
  opacity: 1;
  position: absolute;
  top: 14px;
  white-space: nowrap;
}

.x3916646 {
  border-radius: 5px;
  height: 76px;
  margin-left: 19px;
  opacity: 1;
  position: relative;
  width: 176px;
}

.x3916646 .label-i39166462068-5DPfzb {
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  left: 0;
  letter-spacing: 0;
  line-height: 17px;
  opacity: 1;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.i3916646-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 176px;
}

.i3916646-2079218 .input-text-here-i391-02XhDX {
  color: #0f172a;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  left: 16px;
  letter-spacing: 0;
  line-height: 24px;
  opacity: 1;
  position: absolute;
  top: 14px;
  white-space: nowrap;
}

.x3916647 {
  border-radius: 5px;
  height: 76px;
  margin-left: 13px;
  opacity: 1;
  position: relative;
  width: 176px;
}

.x3916647 .label-i39166472068-6hgxG2 {
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  left: 0;
  letter-spacing: 0;
  line-height: 17px;
  opacity: 1;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.i3916647-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 176px;
}

.i3916647-2079218 .input-text-here-i391-PISlRY {
  color: #0f172a;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  left: 16px;
  letter-spacing: 0;
  line-height: 24px;
  opacity: 1;
  position: absolute;
  top: 14px;
  white-space: nowrap;
}

.db-2 .ccv {
  left: 509px;
  letter-spacing: 0;
  line-height: 24px;
  position: absolute;
  top: 38px;
  white-space: nowrap;
}

.x3916650 {
  height: 16px;
  left: 528px;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 341px;
  width: 16px;
}

.x3916650 .vector-AiedjN {
  height: 6px;
  left: 3px;
  opacity: 1;
  position: absolute;
  top: 5px;
  width: 10px;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}

button {
  border: none;
}
.db-2 .buttonsubscribe {
  align-items: center;
  background-color: var(--djuli-primary-color);
  border-radius: 8px;
  box-shadow: 0px 16px 24px #0000001f;
  cursor: pointer;
  display: flex;
  height: 69px;
  justify-content: flex-end;
  margin-left: 1px;
  margin-top: 44px;
  min-width: 413px;
  padding: 0 47px;
}

.db-2 .text-50 {
  letter-spacing: 0;
  min-height: 21px;
  min-width: 317px;
  text-align: center;
}
/* - 391_6641 */

.x3916641 .label-i39166412068-hVcKjw {
  background-color: transparent;
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 0px;
  letter-spacing: 0px;
  line-height: 17px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 0px;
  white-space: nowrap;
  width: auto;
}

.i3916641-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0px;
  mix-blend-mode: normal;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 560px;
}

.i3916641-2079218 .input-text-here-i391-vY8Ah7 {
  background-color: transparent;
  color: #94a3b8;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - i391_6641-2079_218 */

.i3916641-2079218 .input-text-here-i391-vY8Ah7 {
  background-color: transparent;
  color: #94a3b8;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - 391_6642 */

.x3916642 .label-i39166422068-Hb91Ih {
  background-color: transparent;
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 0px;
  letter-spacing: 0px;
  line-height: 17px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 0px;
  white-space: nowrap;
  width: auto;
}

.i3916642-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0px;
  mix-blend-mode: normal;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 560px;
}

.i3916642-2079218 .input-text-here-i391-gcGk2F {
  background-color: transparent;
  color: #94a3b8;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - i391_6642-2079_218 */

.i3916642-2079218 .input-text-here-i391-gcGk2F {
  background-color: transparent;
  color: #94a3b8;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - 391_6643 */

.x3916643 .label-i39166432068-DB9Rsj {
  background-color: transparent;
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 0px;
  letter-spacing: 0px;
  line-height: 17px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 0px;
  white-space: nowrap;
  width: auto;
}

.i3916643-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0px;
  mix-blend-mode: normal;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 560px;
}

.i3916643-2079218 .input-text-here-i391-2xvqCY {
  background-color: transparent;
  color: #94a3b8;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - i391_6643-2079_218 */

.i3916643-2079218 .input-text-here-i391-2xvqCY {
  background-color: transparent;
  color: #94a3b8;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - 391_6644 */

.x3916644 .label-i39166442068-TJHaj6 {
  background-color: transparent;
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 0px;
  letter-spacing: 0px;
  line-height: 17px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 0px;
  white-space: nowrap;
  width: auto;
}

.i3916644-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0px;
  mix-blend-mode: normal;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 560px;
}

.i3916644-2079218 .input-text-here-i391-nAROfg {
  background-color: transparent;
  color: #0f172a;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - i391_6644-2079_218 */

.i3916644-2079218 .input-text-here-i391-nAROfg {
  background-color: transparent;
  color: #0f172a;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - 391_6645 */

.x3916645 .label-i39166452068-qoI0DB {
  background-color: transparent;
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 0px;
  letter-spacing: 0px;
  line-height: 17px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 0px;
  white-space: nowrap;
  width: auto;
}

.i3916645-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0px;
  mix-blend-mode: normal;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 176px;
}

.i3916645-2079218 .input-text-here-i391-FWsxA8 {
  background-color: transparent;
  color: #0f172a;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - i391_6645-2079_218 */

.i3916645-2079218 .input-text-here-i391-FWsxA8 {
  background-color: transparent;
  color: #0f172a;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - 391_6646 */

.x3916646 .label-i39166462068-5DPfzb {
  background-color: transparent;
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 0px;
  letter-spacing: 0px;
  line-height: 17px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 0px;
  white-space: nowrap;
  width: auto;
}

.i3916646-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0px;
  mix-blend-mode: normal;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 176px;
}

.i3916646-2079218 .input-text-here-i391-02XhDX {
  background-color: transparent;
  color: #0f172a;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - i391_6646-2079_218 */

.i3916646-2079218 .input-text-here-i391-02XhDX {
  background-color: transparent;
  color: #0f172a;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - 391_6647 */

.x3916647 .label-i39166472068-6hgxG2 {
  background-color: transparent;
  color: #475569;
  font-family: "Inter", Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 0px;
  letter-spacing: 0px;
  line-height: 17px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 0px;
  white-space: nowrap;
  width: auto;
}

.i3916647-2079218 {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  height: 52px;
  left: 0px;
  mix-blend-mode: normal;
  opacity: 1;
  overflow: hidden;
  position: absolute;
  top: 24px;
  width: 176px;
}

.i3916647-2079218 .input-text-here-i391-PISlRY {
  background-color: transparent;
  color: #0f172a;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - i391_6647-2079_218 */

.i3916647-2079218 .input-text-here-i391-PISlRY {
  background-color: transparent;
  color: #0f172a;
  font-family: "Inter", Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  height: auto;
  left: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  mix-blend-mode: normal;
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 14px;
  white-space: nowrap;
  width: auto;
}
/* - 391_6650 */

.x3916650 .vector-AiedjN {
  background-color: transparent;
  height: 6px;
  left: 3px;
  opacity: 1;
  position: absolute;
  top: 5px;
  width: 10px;
}
</style>